import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SnIotDefender } from '@lib/api/entities';
import { snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-appliance-event-table',
  templateUrl: './appliance-event-table.component.html',
  styleUrls: ['./appliance-event-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [snFadeIn, snFadeOut, snListStagger],
})
export class ApplianceEventTableComponent extends SnTableBaseComponent<SnIotDefender> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnIotDefender): any {
    return item.id;
  }
}
